const Criterias = {
  methods: {
    getCriteriaFromLocation: key => {
      const wlh = window.location.hash
      if (wlh === "") return null
      try {
        const criteria = wlh.substring(2+key.length)
        return JSON.parse(Buffer.from(criteria, 'hex').toString('utf8'))
      }
      catch (err) {
        return null
      }
    },
    setCriteriaToLocation: (key,criteria) => {
      const c = Buffer.from(JSON.stringify(criteria),'utf8').toString('hex')
      if (criteria!==window.location.hash) {
        window.history.pushState(null, null, window.location.origin+window.location.pathname+'#'+key+'='+c)
      }
    }
  }
}
export default Criterias
